import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import { Button } from '@nexiahome/ui-common/components/primitives/buttons'
import Modal from 'components/Modal'

import Api from 'services/api'

import { ButtonContainer } from 'styles/shared'

import LinearProgress, { LinearProgressProps } from '@mui/material/LinearProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

type Props = {
  isOpen: boolean
  onClose: () => void
  jobId: string
  deviceId: string
}

const RunPastCSVModal = ({ isOpen, onClose, jobId, deviceId }: Props) => {
  const [isRunning, setIsRunning] = useState(true)
  const [progress, setProgress] = useState(0)
  const [csvUrl, setCsvUrl] = useState('')
  const [message, setMessage] = useState('')

  function LinearProgressWithLabel (props: LinearProgressProps & { value: number }) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary' }}
          >{`${Math.round(props.value)}%`}
          </Typography>
        </Box>
      </Box>
    )
  }

  useEffect(() => {
    if (jobId === '') {
      return
    }

    const timer = setInterval(() => {
      Api.DeviceAggregator.getPastFaceplateMessagesCSVStatus(deviceId, jobId)
        .then((res) => {
          const message = res.message ? res.message : ''
          if (res.status === 'complete') {
            if (!message.startsWith('Failed')) {
              setCsvUrl(message)
              setMessage('CSV file is ready')
              setProgress(100)
              setIsRunning(false)
              clearInterval(timer)
            } else {
              setMessage(message)
              clearInterval(timer)
            }
          } else if (res.status === 'failed' || res.status === 'interrupted') {
            setMessage(res.status + ':' + message)
            clearInterval(timer)
          } else {
            setIsRunning(true)
            setProgress(res.pctComplete)
            setMessage(res.status + ':' + message)
          }
        })
        .catch(() => {
          setMessage('Failed: Could not get the CSV report status')
          clearInterval(timer)
        })
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [deviceId, jobId])

  return (
    <Modal
      title="Build 30 day CSV Report"
      closeCallback={onClose}
      isDisplayed={isOpen}
    >
      <Box sx={{ width: '100%' }}>
        <LinearProgressWithLabel value={progress} />
      </Box>
      <S.Message> {message} </S.Message>

      <ButtonContainer noBorder>
        <Button decoration="secondary" styles={{ button: { marginRight: 15 } }} text="Close" onPress={onClose} />
        <a
          type="submit"
          rel="noreferrer"
          target="_blank"
          href={csvUrl}
        >
          <Button decoration="positive" enabled={!isRunning} text="open CSV file" />
        </a>
      </ButtonContainer>
    </Modal>
  )
}

export default RunPastCSVModal

const S = {
  Message: styled.span`
      display: block;
      font-weight: 700;
      font-size: 12px;
  `
}
